module.exports = __webpack_public_path__ + "flyer_background_baby_mobile_098-4219fb18be8dfe68ba6a5ab384a82148.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_baby_mobile_098.jpg
// module id = 1602
// module chunks = 1